import React from 'react';
import PropTypes from 'prop-types';
import { LuShoppingCart as ShoppingCart, LuBell as Bell } from 'react-icons/lu';
import { Link } from 'react-router-dom';

// COMPONENTS
import HeaderMenuDefaultDesktop from 'structure/Menu/DefaultDesktop';
import Icon from 'components/Atoms/Icons/Icon';
import SearchContainer from 'components/Search/SearchContainer';
import Dropdown from 'components/Atoms/Dropdown/Dropdown';
import HeaderProfile from './HeaderProfile';
import HeaderPoints from './HeaderPoints';
import { useNotifications } from '../../../Shared/Notification';
import VertNotifications from 'components/VertNotification';

// DS
import {
  Row,
  VertContainer,
  // VertNotifications,
  VertTag,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Header/HeaderStyles.less';
import ynToBool from 'Utils/ynToBool';

// HEADER DESKTOP COMPONENT
const HeaderDesktop = ({
  logo,
  openCloseCartDrawerHandler,
  quantityItemsCart,
}) => {
  const { notifications } = useNotifications();
  const isHeaderFixed = process.env.REACT_HEADER_FIXED === 'true'; 

  /* Renders */
  return (
    <VertContainer
      fluid
        className={isHeaderFixed ? "header-desktop-container-fixed" : "header-desktop-container"} 
      >
      <VertContainer className="vert-box-header" spacingX="regular">
        <div className="header-main-content" justify="space-between">
          <div className="header-logo">
            <Link to={'/'} title="Ir para página inicial">
              <img src={logo} alt={`logotipo ${process.env.REACT_APP_TITLE}`} />
            </Link>
          </div>

          {!ynToBool(process.env.REACT_APP_HIDE_SEARCH_BOX) && (
            <>
              <div className="header-search">
                <SearchContainer />
              </div>
              <div style={{ flex: 1 }} />
            </>
          )}
          {!ynToBool(process.env.REACT_APP_HIDE_CONTENT_POINTS) && (
            <HeaderPoints />
          )}

          <HeaderProfile />

          {!ynToBool(process.env.REACT_APP_HIDE_NOTIFICATIONS) && (
            <div className="header-notifications">
              <div className="notifications-icon">
                <VertNotifications
                  template="marketplace"
                  items={notifications
                    ?.filter((item) => item.toJSON)
                    ?.map((item) => item.toJSON())}
                  icon={
                    <Icon className="lucide" size={`18px`} component={Bell} />
                  }
                />
              </div>
            </div>
          )}
          {!ynToBool(process.env.REACT_APP_HIDE_CART) && (
            <div
              className="header-checkout"
              onClick={openCloseCartDrawerHandler}
            >
              <Icon className="lucide" size={`18px`} component={ShoppingCart} />
              <div className="vert-header-checkout-badge">
                <span className="header-checkout-badge">
                  {quantityItemsCart}
                </span>
              </div>
            </div>
          )}
        </div>

        <HeaderMenuDefaultDesktop />
      </VertContainer>
    </VertContainer>
  );
};

HeaderDesktop.propTypes = {
  logo: PropTypes.string,
  openCloseCartDrawerHandler: PropTypes.func,
  searchButtonHandler: PropTypes.func,
  quantityItemsCart: PropTypes.number,
};

export default HeaderDesktop;
